import ApplicantManual from '@/components/services/RUZDI/Applicant/Manual/index.vue';

import ExtractType from '@/components/services/RUZDI/ExtractType.vue';
import Pledgor from '@/components/services/RUZDI/Pledgor/index.vue';
import AccountBankDetails from '@/components/services/RUZDI/AccountBankDetails.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [ExtractType, Pledgor, AccountBankDetails];
const steps: unknown[] = [ApplicantManual, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const ruzdiSteps: unknown[] = isMrpaEnable(StatementType.RUZDI) ? mrpaSteps : steps;
